import {Component} from '@angular/core';
import {Observable, tap} from "rxjs";
import {UIService} from './@core/ui.service';
import {environment} from '../environments/environment';
import packageJson from '../../package.json';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {

  error$?: Observable<any>;
  isVisible = false;
  version: string = packageJson.version;

  constructor(private ui: UIService) {
    this.error$ = ui.error$.asObservable().pipe(tap(() => this.isVisible = true));
    const version = `v${this.version}${environment.production ? 'p' : 'u'}`;
    document.title = 'Hall Application ' + `[${version}]`;
  }

}
